import { Tooltip } from '@vd/ui';
import type { ReportPatterns } from '../../lib/api';
import styles from '../../routes/ReportsPage.module.css';

/**
 * What Chronic and Spike mean, in one place, so the badges' tooltips and the
 * cards' info text cannot drift (TOADO-946). The rule is `rhythmOf` in the
 * API's reportGrouping.ts, over the last 8 weeks.
 */
export const RHYTHM_TIPS = {
  chronic: 'Tickets in 3 or more of the last 8 weeks: a page that keeps having problems.',
  spike: 'Tickets in only 1 of the last 8 weeks: something that went wrong once.',
} as const;

/** Chronic or spike, with what it means on hover and on keyboard focus. */
export function RhythmTag({ entry }: { entry: Pick<ReportPatterns['rhythm'][number], 'rhythm'> }) {
  const chronic = entry.rhythm === 'chronic';
  return (
    <Tooltip content={chronic ? RHYTHM_TIPS.chronic : RHYTHM_TIPS.spike} multiline>
      <span
        className={`${styles.tag} ${chronic ? styles.tagChronic : styles.tagSpike}`}
        tabIndex={0}
        data-testid="rhythm-tag"
      >
        {chronic ? 'Chronic' : 'Spike'}
      </span>
    </Tooltip>
  );
}
